<script>
    import downloadsIcon from 'src/components/main/home/components/our-mission/downloads.svg'
    import background from 'src/components/main/home/components/our-mission/background.jpg'
    import {getSettingOption} from 'src/components/cabinet/#services/settingsOption'

    getSettingOption.send({ data: { clientKey: 'website.ourMission' } })
</script>

<section style="--Background:url({background});">
    <div class="container">
        <div class="our-mission">
            <div class="title">Our Mission<br>Mass Adoption through Gaming</div>
            <div class="description">Creating the bridge between WEB 2 platforms and WEB 3 world</div>
            <div class="count notranslate">100 millions</div>
            <div class="text-center">
                <div class="duration">installs in 5 years <img src="{downloadsIcon}" alt="downloads"></div>
            </div>
            <div class="progress-line">
                {#if $getSettingOption.hasValue}
                    <div class="progress-completed" style="width: {$getSettingOption.value?.value}%;"></div>
                {:else}
                    <div class="progress-completed" style="width: 1%;"></div>
                {/if}
            </div>
            <div class="progress-text">
                {#if $getSettingOption.hasValue}
                    {$getSettingOption.value?.value} mln <span class="installed">installed</span>
                {:else}
                    Loading...
                {/if}
            </div>
            <div class="row">
                <div class="col-lg-6">
                    <div class="left-title">What is important to us</div>
                </div>
                <div class="col-lg-6">
                    <div class="mini-card">
                        <div class="subtitle">Simplicity</div>
                        <div class="caption">We simplify blockchain through games creating fun apps with simple mechanics and following users step-by-step. We give users interesting games, and then they native dive into crypto.</div>
                    </div>
                    <div class="mini-card">
                        <div class="subtitle">Utility</div>
                        <div class="caption">We want to transform the market and give more value to players. In our games, users don't just interact with the blockchain, they use it by making in-game purchases with LIS tokens and fighting with NFT units in battle.</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<style>
    section {
        background: var(--Background) no-repeat center top;
        background-position-y: -150px;
        margin: -400px 0;
        padding: 450px 0;
        position: relative;
        z-index: 2;
    }

    .title {
        text-align: center;
        font-size: 70px;
        color: white;
        font-family: 'Anton', sans-serif;
        line-height: 1.1;
        letter-spacing: 2.8px;
        margin: 0 0 30px;
    }

    .description {
        color: #CED5E3;
        text-align: center;
        font-size: 20px;
        font-weight: 500;
        line-height: 1.5;
        margin: 0 0 150px;
    }

    .count {
        font-size: 250px;
        font-family: 'Anton', sans-serif;
        line-height: 1;
        margin: 150px 0 50px;
        text-align: center;
        background: radial-gradient(116.47% 118.09% at 98.58% 96.58%, #FE8116 0%, #FF4520 100%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        white-space: nowrap;
    }

    .duration {
        border-radius: 16px;
        font-size: 30px;
        margin: 0 0 120px;
        color: white;
        border: 1px solid #91A2FA;
        background: linear-gradient(180deg, rgba(255, 255, 255, 0.10) 0%, rgba(255, 255, 255, 0.00) 100%);
        backdrop-filter: blur(5px);
        display: inline-block;
        line-height: normal;
        padding: 12px 12px 12px 30px;
    }

    .duration img {
        margin-left: 30px;
    }

    .progress-line {
        border-radius: 4px;
        background: rgba(255, 255, 255, 0.10);
        backdrop-filter: blur(10px);
        height: 20px;
    }

    .progress-completed {
        border-radius: 4px;
        height: 100%;
        min-width: 20px;
        max-width: 100%;
        background: linear-gradient(152deg, #15BFFD 9.96%, #9C37FD 100%);
        position: relative;
        transition: .25s;
    }

    .progress-completed:after {
        content: "";
        position: absolute;
        width: 60px;
        height: 60px;
        background: rgba(63, 149, 253, 0.5);
        -webkit-filter: blur(25px);
        filter: blur(25px);
        top: -20px;
        right: -30px;
        z-index: 2;
    }

    .progress-text {
        text-align: center;
        color: #CED5E3;
        font-size: 70px;
        font-style: normal;
        font-weight: 100;
        line-height: 1;
        margin: -46px 0 300px;
        z-index: 3;
        position: relative;
    }

    .left-title {
        color: white;
        font-family: 'Anton', sans-serif;
        font-size: 50px;
        font-weight: 400;
        line-height: 1.1;
    }

    .mini-card {
        border: 2px solid #3d3083;
        margin-bottom: 30px;
        border-radius: 16px;
        padding: 40px;
    }

    .subtitle {
        color: #626ED9;
        font-family: 'Anton', sans-serif;
        font-size: 30px;
        margin-bottom: 20px;
        font-weight: 400;
        line-height: 1.1;
    }

    .caption {
        color: #CED5E3;
        font-size: 18px;
        font-weight: 400;
        line-height: 1.3;
    }

    .installed {
        font-size: 40px;
    }

    @media(max-width: 1400px) {
        .count {
            font-size: 230px;
        }
    }

    @media (max-width: 1200px) {
        section {
            margin: -100px 0 -300px;
            padding: 300px 0;
            background-size: 100%;
        }

        .title {
            font-size: 66px;
        }

        .count {
            font-size: 190px;
        }

        .left-title {
            font-size: 40px;
        }

        .progress-text {
            font-size: 60px;
        }

        .duration {
            font-size: 25px;
        }

        .installed {
            font-size: 34px;
        }
    }

    @media (max-width: 991px) {
        section {
            margin: -150px 0 150px;
            padding: 250px 0 0;
            background-position-y: -70px;
        }

        .title {
            font-size: 50px;
        }

        .count {
            font-size: 140px;
        }

        .duration {
            font-size: 20px;
        }

        .duration img {
            margin-left: 15px;
            width: 40px;
        }

        .progress-text {
            font-size: 55px;
            margin: -40px 0 160px;
        }

        .left-title {
            text-align: center;
            margin: 0 0 40px;
        }
    }

    @media(max-width: 767px) {
        .count {
            font-size: 60px;
            margin: 50px 0 30px;
        }

        .title {
            font-size: 40px;
        }

        .description {
            font-size: 16px;
            margin: 0 0 80px;
        }

        .duration img {
            width: 30px;
        }

        .duration {
            font-size: 16px;
            padding: 10px 10px 10px 22px;
        }

        .progress-text {
            font-size: 36px;
            margin: -26px 0 120px;
        }

        .progress-line {
            height: 14px;
        }

        .left-title {
            font-size: 34px;
            margin-bottom: 30px;
        }

        section {
            margin-bottom: 100px;
            background-position-y: 70px;
        }

        .mini-card {
            margin-bottom: 12px;
            padding: 15px;
        }

        .subtitle {
            font-size: 24px;
            margin-bottom: 14px;
        }

        .caption {
            font-size: 16px;
        }

        .installed {
            font-size: 20px;
        }
    }
</style>
